module.exports = __webpack_public_path__ + "img/number-thumb-12.05b5b13d.jpg";